<footer #footerLayoutContainer [ngStyle]="footerOuterCss" class="footer-layout-container">
  <ng-container *ngFor="let component of injectorArray; trackBy: trackByFooterWidgetLayouts">
    @if(configService.getActiveConfigType().isWorkflow) {
    <div
      pDroppable="dd"
      (onDrop)="drop(component.widget)"
      class="main-widget-contents"
      [ngClass]="component.widget.uniqueId === mouseOverId ? mouseOver : ''"
      (click)="selectWidget($event, component.widget)"
      (mouseover)="updateHoverState($event, component.widget.uniqueId.toString())"
      (mouseout)="updateHoverState($event)"
    >
      <div [class]="getWidgetClasses(component.widget)">
        <ng-container *ngComponentOutlet="component.component; injector: component.injector"></ng-container>
      </div>
    </div>
    } @else {
    <div [class]="getWidgetClasses(component.widget)">
      <ng-container *ngComponentOutlet="component.component; injector: component.injector"></ng-container>
    </div>
    }
  </ng-container>
</footer>
